import { ApiClient } from "../ApiClient";

const RECURRING_TRANSACTIONS_ENDPOINT = "finances/recurring-transactions";

/**
 * Fetches all recurring transactions with optional filtering
 */
export const getRecurringTransactions = async (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  const url = queryString
    ? `${RECURRING_TRANSACTIONS_ENDPOINT}?${queryString}`
    : RECURRING_TRANSACTIONS_ENDPOINT;

  const res = await ApiClient.get(url);
  return await res.json();
};

/**
 * Fetches specific details for a single recurring transaction
 */
export const getRecurringTransactionDetail = async (rt_uuid) => {
  const res = await ApiClient.get(
    `${RECURRING_TRANSACTIONS_ENDPOINT}/${rt_uuid}`,
  );
  return await res.json();
};

export const updateRecurringTransaction = async (rt_uuid, data) => {
  const res = await ApiClient.patch(
    `${RECURRING_TRANSACTIONS_ENDPOINT}/${rt_uuid}`,
    data,
  );

  if (!res.ok) {
    const errorBody = await res.json().catch(() => ({}));
    throw new Error(
      errorBody.detail || "Unable to update recurring transaction.",
    );
  }

  return await res.json();
};
